// src/AGTUps-Product/services/AGTUps-product-services/budgetService.js
import { api } from './config';

class BudgetService {
  /**
   * Crea un nuevo presupuesto.
   */
  static async createBudget(budgetData) {
    try {
      const response = await api.post('/budget', budgetData);
      return response.data;
    } catch (error) {
      throw new Error(`Error creating budget: ${error.message}`);
    }
  }

  /**
   * Obtiene todos los presupuestos del usuario.
   */
  static async getBudgets() {
    try {
      const response = await api.get('/budget');
      return response.data;
    } catch (error) {
      throw new Error(`Error fetching budgets: ${error.message}`);
    }
  }

  /**
   * Obtiene un presupuesto específico por su ID.
   */
  static async getBudgetById(budgetId) {
    try {
      const response = await api.get(`/budget/${budgetId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error fetching budget: ${error.message}`);
    }
  }

  /**
   * Actualiza un presupuesto existente.
   */
  static async updateBudget(budgetId, updateData) {
    try {
      const response = await api.put(`/budget/${budgetId}`, updateData);
      return response.data;
    } catch (error) {
      throw new Error(`Error updating budget: ${error.message}`);
    }
  }

  /**
   * Elimina un presupuesto.
   */
  static async deleteBudget(budgetId) {
    try {
      const response = await api.delete(`/budget/${budgetId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error deleting budget: ${error.message}`);
    }
  }

  // ========================================
  // Métodos para manejar categorías
  // ========================================

  /**
   * Crea una nueva categoría en un presupuesto.
   * @param {string} budgetId - ID del presupuesto.
   * @param {object} categoryData - Datos de la categoría.
   */
  static async createCategory(budgetId, categoryData) {
    try {
      const response = await api.post(`/budget/${budgetId}/category`, categoryData);
      return response.data;
    } catch (error) {
      throw new Error(`Error creating category: ${error.message}`);
    }
  }

  /**
   * Actualiza una categoría existente en un presupuesto.
   * @param {string} budgetId - ID del presupuesto.
   * @param {string} categoryId - ID de la categoría.
   * @param {object} updateData - Datos a actualizar.
   */
  static async updateCategory(budgetId, categoryId, updateData) {
    try {
      const response = await api.put(`/budget/${budgetId}/category/${categoryId}`, updateData);
      return response.data;
    } catch (error) {
      throw new Error(`Error updating category: ${error.message}`);
    }
  }

  /**
   * Elimina una categoría de un presupuesto.
   * @param {string} budgetId - ID del presupuesto.
   * @param {string} categoryId - ID de la categoría.
   */
  static async deleteCategory(budgetId, categoryId) {
    try {
      const response = await api.delete(`/budget/${budgetId}/category/${categoryId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error deleting category: ${error.message}`);
    }
  }

  /**
   * Obtiene un análisis comparativo del presupuesto versus los gastos reales.
   * @param {string} budgetId - ID del presupuesto.
   */
  static async getBudgetAnalysis(budgetId) {
    try {
      const response = await api.get(`/budget/${budgetId}/analysis`);
      return response.data;
    } catch (error) {
      throw new Error(`Error analyzing budget: ${error.message}`);
    }
  }
}

export default BudgetService;
